export default __webpack_public_path__ + "static/media/img-contactus-header.f9da4b19.jpg";